import React from 'react';
import { CheckCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const ProcessSection = () => {
  const { t } = useTranslation('bonding');
  const steps = [
    {
      number: t('process.steps.0.number'),
      title: t('process.steps.0.title'),
      description: t('process.steps.0.description'),
    },
    {
      number: t('process.steps.1.number'),
      title: t('process.steps.1.title'),
      description: t('process.steps.1.description'),
    },
    {
      number: t('process.steps.2.number'),
      title: t('process.steps.2.title'),
      description: t('process.steps.2.description'),
    },
    {
      number: t('process.steps.3.number'),
      title: t('process.steps.3.title'),
      description: t('process.steps.3.description'),
    },
    {
      number: t('process.steps.4.number'),
      title: t('process.steps.4.title'),
      description: t('process.steps.4.description'),
    }
  ];

  return (
    <section id="process" className="py-16 lg:py-20 bg-dental-light/20 relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute top-20 right-0 w-80 h-80 bg-dental/10 rounded-full blur-3xl -z-10"></div>
      <div className="absolute bottom-20 left-0 w-60 h-60 bg-dental-coral/10 rounded-full blur-3xl -z-10"></div>
      
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-display font-bold mb-4 text-gradient-primary inline-block relative reveal" data-direction="up">
            {t('process.heading')}
          </h2>
          <p className="text-xl text-dental-dark/80 max-w-3xl mx-auto reveal" data-direction="up">
            {t('process.intro')}
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {steps.map((step, index) => (
            <div 
              key={index} 
              className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-md transition-shadow relative reveal" 
              data-direction="up" 
              data-delay={0.1 * index}
            >
              <span className="text-5xl font-bold text-dental-light absolute -top-6 right-4">{step.number}</span>
              <h3 className="text-xl font-display font-bold mb-4 text-dental-dark">{step.title}</h3>
              <p className="text-dental-dark/70">{step.description}</p>
            </div>
          ))}
        </div>
        
        <div className="mt-16 bg-white rounded-2xl p-8 shadow-md reveal" data-direction="up">
          <h3 className="text-2xl font-display font-bold mb-6 text-dental-dark">{t('process.expected.heading')}</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <ul className="space-y-4">
                <li className="flex items-start">
                  <CheckCircle className="h-6 w-6 text-dental-coral mr-3 mt-0.5 flex-shrink-0" />
                  <p className="text-dental-dark/80">{t('process.expected.left.0')}</p>
                </li>
                <li className="flex items-start">
                  <CheckCircle className="h-6 w-6 text-dental-coral mr-3 mt-0.5 flex-shrink-0" />
                  <p className="text-dental-dark/80">{t('process.expected.left.1')}</p>
                </li>
                <li className="flex items-start">
                  <CheckCircle className="h-6 w-6 text-dental-coral mr-3 mt-0.5 flex-shrink-0" />
                  <p className="text-dental-dark/80">{t('process.expected.left.2')}</p>
                </li>
              </ul>
            </div>
            <div>
              <ul className="space-y-4">
                <li className="flex items-start">
                  <CheckCircle className="h-6 w-6 text-dental-coral mr-3 mt-0.5 flex-shrink-0" />
                  <p className="text-dental-dark/80">{t('process.expected.right.0')}</p>
                </li>
                <li className="flex items-start">
                  <CheckCircle className="h-6 w-6 text-dental-coral mr-3 mt-0.5 flex-shrink-0" />
                  <p className="text-dental-dark/80">{t('process.expected.right.1')}</p>
                </li>
                <li className="flex items-start">
                  <CheckCircle className="h-6 w-6 text-dental-coral mr-3 mt-0.5 flex-shrink-0" />
                  <p className="text-dental-dark/80">{t('process.expected.right.2')}</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
